import * as React from 'react';
import { Button, MessageBar, MessageBarActions, MessageBarBody, MessageBarTitle } from '@fluentui/react-components';
import { ArrowClockwise16Regular, Dismiss16Regular } from '@fluentui/react-icons';

export interface IErrorBarProps {
    message?: string;
    title?: string;
    onRetry?: () => void;
    onDismiss?: () => void;
    intent?: 'error' | 'warning' | 'info';
}

/** Inline error with optional retry. Renders nothing when there is no message. */
const ErrorBar: React.FC<IErrorBarProps> = ({ message, title, onRetry, onDismiss, intent = 'error' }) => {
    if (!message) return null;
    return (
        <MessageBar intent={intent} layout="multiline" role="alert">
            <MessageBarBody>
                {title && <MessageBarTitle>{title}</MessageBarTitle>}
                {message}
            </MessageBarBody>
            {(onRetry || onDismiss) && (
                <MessageBarActions
                    containerAction={onDismiss ? (
                        <Button appearance="transparent" icon={<Dismiss16Regular />} aria-label="Закрыть" onClick={onDismiss} />
                    ) : undefined}
                >
                    {onRetry && (
                        <Button appearance="secondary" size="small" icon={<ArrowClockwise16Regular />} onClick={onRetry}>
                            Повторить
                        </Button>
                    )}
                </MessageBarActions>
            )}
        </MessageBar>
    );
};

export default ErrorBar;
